import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { Reveal } from "./Reveal";
import { useContent } from "@/content";

const API = `${process.env.REACT_APP_BACKEND_URL}/api`;

export const FeaturedPiece = () => {
  const c = useContent();
  const slug = c.featured_slug || "young-gifted-and-black";
  const [entry, setEntry] = useState(null);

  useEffect(() => {
    setEntry(null);
    axios
      .get(`${API}/entries/${slug}`)
      .then((r) => setEntry(r.data))
      .catch(() => {});
  }, [slug]);

  if (!entry) return null;

  return (
    <section className="px-6 sm:px-12 lg:px-20 pb-24 sm:pb-32 max-w-7xl mx-auto" data-testid="featured-piece">
      <Reveal>
        <Link
          to={`/archive/${entry.slug}`}
          data-testid="featured-piece-link"
          className="group block border border-blue-100/15 p-8 sm:p-14 hover:bg-[#4F7CFF] transition-colors duration-300"
        >
          <div className="flex items-center gap-4 font-meta text-[10px] sm:text-xs tracking-[0.3em] text-blue-300/60 group-hover:text-white/70 transition-colors duration-300">
            <span>FEATURED PIECE</span>
            <span className="w-8 h-px bg-current" />
            <span>{entry.date_display}</span>
          </div>
          <h3 className="font-display font-extrabold uppercase tracking-tighter leading-[0.95] text-[clamp(2.2rem,6vw,5rem)] mt-6">
            {entry.title}
          </h3>
          {entry.pull_quote && (
            <p className="font-display text-lg sm:text-2xl font-bold uppercase tracking-tight leading-snug text-blue-100/70 group-hover:text-white/85 mt-6 max-w-3xl transition-colors duration-300">
              “{entry.pull_quote}”
            </p>
          )}
          <span className="inline-block mt-8 font-meta text-xs tracking-[0.25em] border border-blue-200/30 group-hover:border-white/50 rounded-full px-6 py-3 transition-colors duration-300">
            READ THE PIECE →
          </span>
        </Link>
      </Reveal>
    </section>
  );
};
